var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownFill = function SvgArrowDownFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.765 10h-6.53c-.196 0-.305.196-.184.33l3.265 3.593a.258.258 0 0 0 .368 0l3.265-3.593c.121-.134.012-.33-.184-.33Z",
    fill: "#606060"
  })));
};
export default SvgArrowDownFill;